var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrashCanGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.3335 6.99992H33.6668V10.3333H30.3335V31.9999C30.3335 32.4419 30.1579 32.8659 29.8453 33.1784C29.5328 33.491 29.1089 33.6666 28.6668 33.6666H5.3335C4.89147 33.6666 4.46755 33.491 4.15499 33.1784C3.84242 32.8659 3.66683 32.4419 3.66683 31.9999V10.3333H0.333496V6.99992H8.66683V1.99992C8.66683 1.55789 8.84243 1.13397 9.15499 0.821407C9.46755 0.508847 9.89147 0.333252 10.3335 0.333252H23.6668C24.1089 0.333252 24.5328 0.508847 24.8453 0.821407C25.1579 1.13397 25.3335 1.55789 25.3335 1.99992V6.99992ZM27.0002 10.3333H7.00016V30.3333H27.0002V10.3333ZM12.0002 15.3333H15.3335V25.3333H12.0002V15.3333ZM18.6668 15.3333H22.0002V25.3333H18.6668V15.3333ZM12.0002 3.66659V6.99992H22.0002V3.66659H12.0002Z",
    fill: "#008662"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashCanGreen);
export default __webpack_public_path__ + "static/media/trash-can-green.1352c89f914e7bf838af8278014c31e1.svg";
export { ForwardRef as ReactComponent };